"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.57 8.47v-.18a.342.342 0 0 0 0-.1.316.316 0 0 0 0-.09.316.316 0 0 0 0-.09L11.3 2.56a.5.5 0 0 0-.67-.18L4.5 5.81l-2.87 2-.08.08-.11.11v.27a.28.28 0 0 0 0 .09.37.37 0 0 0 .05.11v.06l.07.07s.05.05.08.06l6.12 3.42a.5.5 0 0 0 .48 0l6.12-3.42h.06l.09-.08.06-.11Zm-3.88-5 2.74 4.58L8.18 11 5.44 6.43l5.25-2.96ZM4.59 7l2 3.37-3.78-2.16L4.59 7Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.742 9.615a.26.26 0 0 0 0-.083.37.37 0 0 0 0-.097L16.77 1.2a.555.555 0 0 0-.75-.195l-9.18 5.13-4.305 3a.563.563 0 0 0-.24.465v7.725a.555.555 0 0 0 .292.487l9.188 5.138c.08.04.166.064.255.067.08.013.162.008.24-.015l9.195-5.137a.547.547 0 0 0 .285-.488V9.645s0-.023-.008-.03Zm-5.64-7.388 4.305 7.185-8.205 4.613L7.89 6.84l8.212-4.613ZM3.352 9.915l3.585-2.438 4.5 7.5v6.608l-8.07-4.5-.015-7.17Zm9.21 11.632v-6.435l8.063-4.5v6.435l-8.063 4.5Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.99 12.82a.35.35 0 0 0 0-.11.505.505 0 0 0 0-.13L22.36 1.6a.74.74 0 0 0-1-.26L9.12 8.18l-5.74 4a.75.75 0 0 0-.32.62v10.3a.74.74 0 0 0 .39.65L15.7 30.6a.818.818 0 0 0 .34.09.74.74 0 0 0 .32-.02l12.26-6.85a.73.73 0 0 0 .38-.65V12.86s0-.03-.01-.04Zm-7.52-9.85 5.74 9.58-10.94 6.15-5.75-9.58 10.95-6.15Zm-17 10.25 4.78-3.25 6 10v8.81l-10.76-6-.02-9.56Zm12.28 15.51v-8.58l10.75-6v8.58l-10.75 6Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.282 19.237v-.195a.622.622 0 0 0-.06-.165v-.045c0-.045 0 0 0 0l-9.75-16.297a.945.945 0 0 0-1.267-.338L13.83 12.472h-.045l-8.61 6a.952.952 0 0 0-.398.75v15.45a.93.93 0 0 0 .48.818l18.375 10.275h.135a.99.99 0 0 0 .323.067.916.916 0 0 0 .322-.067h.143L42.93 35.49a.93.93 0 0 0 .48-.818V19.29s-.128-.038-.128-.053Zm-11.032-15 8.805 14.693-16.718 9.367-8.805-14.692L32.25 4.237ZM6.532 19.777l7.38-5.175 9.12 15.218v13.597l-16.5-9.232V19.777Zm18.375 23.64V30.112l16.5-9.225v13.298l-16.5 9.232Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M57.71 25.65v-.26a.829.829 0 0 0-.08-.22v-.06c0-.06 0 0 0 0l-13-21.73a1.26 1.26 0 0 0-1.69-.45l-24.5 13.7h-.06l-11.48 8a1.27 1.27 0 0 0-.53 1v20.6a1.24 1.24 0 0 0 .64 1.09l24.5 13.7h.18c.137.054.283.084.43.09a1.22 1.22 0 0 0 .43-.09h.19l24.5-13.7a1.24 1.24 0 0 0 .64-1.09V25.72s-.17-.05-.17-.07ZM43 5.65l11.74 19.59-22.29 12.49-11.74-19.59L43 5.65ZM8.71 26.37l9.84-6.9 12.16 20.29v18.13l-22-12.31V26.37Zm24.5 31.52V40.15l22-12.3v17.73l-22 12.31Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconCeilingOther = function IconCeilingOther(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Ceiling Other' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "CeilingOther"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconCeilingOther.sizes = [16, 24, 32, 48, 64];
IconCeilingOther.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconCeilingOther;
exports.default = _default;